import { Component, EventEmitter, Input, Output } from '@angular/core';

import { isLive, VideoModel } from '../../../models';

@Component({
  selector: 'app-video-thumb',
  templateUrl: './video-thumb.component.html',
  styleUrls: ['./video-thumb.component.scss']
})
export class VideoThumbComponent {
  @Input() video: VideoModel;

  @Output()
  videoSelected: EventEmitter<VideoModel> = new EventEmitter<VideoModel>();

  get hasMultipleVideos(): boolean {
    return (isLive(this.video.pro) || isLive(this.video.liv) || isLive(this.video.qui));
  }

  public show360: boolean = false;

  public onVideoClicked(video: VideoModel): void {
    this.videoSelected.emit(video);
  }
}
